var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.appOwnerCheck,
          expression: "appOwnerCheck",
        },
      ],
      staticClass: "c-header__topbar-icon u-position-relative",
      class: { "unread-notification": _vm.hasNotifications },
      on: {
        click: function ($event) {
          return _vm.$emit("on-toggle")
        },
      },
    },
    [
      _c("i", { staticClass: "fal fa-bell" }),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasNotifications && _vm.notificationsListVisible,
              expression: "hasNotifications && notificationsListVisible",
            },
          ],
          staticClass:
            "c-submenu c-submenu--right c-submenu--top-right-arrow c-submenu--for-notification",
        },
        [
          _vm._l(_vm.notifications, function (notification) {
            return _c(
              "li",
              {
                key: "notification-" + notification.uuid,
                staticClass: "c-submenu__item u-border-bottom",
                on: {
                  click: function ($event) {
                    return _vm.notificationClick(notification)
                  },
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "c-submenu__link l-flex u-ai-start u-jc-sb" },
                  [
                    _c("div", [
                      _c("div", { staticClass: "c-submenu__link-title" }, [
                        _vm._v(_vm._s(notification.title)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "c-submenu__link-text u-text-right" },
                      [
                        _vm._v(
                          _vm._s(_vm.formatDate(notification.date_created))
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLoadMoreButton,
                  expression: "showLoadMoreButton",
                },
              ],
              staticClass: "c-submenu__loadmore",
              on: { click: _vm.loadMoreNotificationsClick },
            },
            [_vm._v("\n      Show All Notifications\n    ")]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }